// src/pages/ThinkBiologyHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const ThinkBiologyHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLogged = authState?.isLogged || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    { label: "Immersive Books", emoji: "📚", link: "/thinkbiology-bookworld" },
    { label: "Immersive Bookshelf", emoji: "📖", link: "/bookshelf" },
    { label: "Assignments", emoji: "📝", link: "/assignments-others" },
    { label: "Practice Test", emoji: "⏱️", link: "/certification-test-others" },
    { label: "Certifications", emoji: "🏅", link: "/my-certificates-others" },
    { label: "Deep Thinking", emoji: "🧠", link: "/fivewhys-analysis-home" },
    { label: "Daily Knowledge", emoji: "📅", link: "/tonic-knowledge" },
    { label: "Biology Tonic", emoji: "⚗️", link: "/tonic-biology" },
    { label: "Counsellors", emoji: "🧑‍🏫", link: "/think5whys-counsellors" },
    { label: "Online Events", emoji: "🎥", link: "/event-flow-home" },
    { label: "Test Series", emoji: "📊", link: "/testbook" },
    { label: "Quizzes", emoji: "❓", link: "/quizcorner-home" },    
    { label: "Biology Games", emoji: "🎲", link: "" },
    { label: "biologyTube", emoji: "🎥", link: "/mathtube" },   
    { label: "Podcast", emoji: "🎙️", link: "/podcast-mylist" },   
    { label: "Biology Marketplace", emoji: "🛍️", link: "/khareedo" },   
    { label: "Kharcho Jeeto", emoji: "🎉", link: "/kharchojeeto" },   
    { label: "AI Counselling", emoji: "🤖", link: "/aicounselling" },   
    { label: "Applause", emoji: "👏", link: "/applause-hub-home" },   
    { label: "Marksheet Contest", emoji: "📄", link: "/applause-hub-home" },   
    { label: "Learners Diary", emoji: "📔", link: "/mydiary-home" },   
    { label: "Teachers Diary", emoji: "📘", link: "/mydiary-home" },   
    { label: "Biology POV", emoji: "👁️", link: "/povify-home" },   
    { label: "VisualBrief", emoji: "🧪", link: "/visualbrief-home" }, 
    { label: "Open Learnings", emoji: "🎓", link: "" },   
  ];

  return (
    <div className="min-h-screen flex flex-col bg-black text-cyan-100 font-sans">
      <header className="sticky top-0 z-50 bg-black px-4 py-1 flex items-center justify-between shadow-lg border-b border-cyan-400">
        <div className="flex flex-col">
          <div className="text-xl lg:text-2xl font-bold text-yellow-200 flex items-center gap-1">
            🧬 ThinkBiology
          </div>
          <div className="text-[11px] text-gray-200">
            Biology studies life and living systems
          </div>
        </div>
        <div className="hidden md:flex items-center gap-3">
          {isLogged ? (
            <>
              <div className="text-xs text-white">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-16 p-2 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-16 px-3 py-1 rounded-full border border-white text-sm hover:bg-white/10"
              >
                🔐
              </button>
            </>
          )}
        </div>

        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-xl lg:text-2xl text-white"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-orange-900 border-b border-orange-800 px-4 py-3 animate-[fadeIn_0.3s_ease-in-out]">
          {isLogged ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-xs text-white font-medium flex items-center gap-1">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-16 p-2 rounded-md bg-red-600 hover:bg-red-700"
              >
                ⏻
              </button>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="w-16 text-white">🔐</Link>
            </div>
          )}
        </div>
      )}
      <div className="min-h-[85vh]">
        <div className="bg-cyan-800 text-white text-xs lg:text-sm py-2">
          <div className="px-1 flex flex-wrap justify-center gap-2">
            <a href="/thinkbiology-why" className="hover:text-yellow-200">🧠 About</a>
            <Link to="/litenshort" className="hover:text-yellow-200">📰 News</Link>
            <a href="/tonic-leaderboard" className="hover:text-yellow-200">🏆 Rankings</a>
            {/* <a href="/chemtube" className="hover:text-yellow-200">🎥ChemTube</a> */}
            <a href="/orderflow-earning-estimator" className="hover:text-yellow-200">💰 Pocket Money</a>
            <a href="/agenticsim" className="hover:text-yellow-200">🤖 Thinky</a>
          </div>
        </div>
        <div className="relative w-full h-8 bg-black overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-cyan-500 to-transparent blur-sm"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-400 to-transparent h-[2px] top-1/2 -translate-y-1/2"></div>
        </div>      
        <div className="mt-1 mb-1 px-3 py-2 border-b border-cyan-700 bg-black">
          <div className="grid grid-cols-4 lg:grid-cols-6 gap-1 place-items-center">
            {groupNames.map((group) => (
              <button
                key={group.label}
                onClick={() => navigate(group.link)}
                className="flex flex-col items-center justify-center w-full px-1 py-2 rounded-md text-xs lg:text-sm font-medium transition bg-cyan-800/50 border border-white/20 hover:bg-cyan-700/70"
              >
                <span className="text-lg">{group.emoji}</span>
                <span className="mt-1 text-center">{group.label}</span>
              </button>
            ))}
          </div>
        </div>
        <div className="relative w-full h-8 bg-black overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-cyan-500 to-transparent blur-sm"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-orange-400 to-transparent h-[2px] top-1/2 -translate-y-1/2"></div>
        </div>
      </div>
      <footer className="bg-black border-t border-cyan-400 text-white py-2">
        <div className="px-3 flex flex-col lg:flex-row items-center justify-between gap-1">
          <div className="text-xs lg:text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-cyan-300">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-cyan-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-cyan-300">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-cyan-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ThinkBiologyHome;
